import { SingleFieldPresenter } from '@/forms/components/presenters/SingleFieldPresenter';
import { FormFieldType, type SingleFormField } from '@/forms/typings';

import type { FormFieldModule } from '../registry/field-module.types';

import { buildSingleFieldInitialState } from './initialState';

export const singleFieldModule: FormFieldModule = {
  type: FormFieldType.Input,
  Presenter: ({ field, disabled }) => (
    <SingleFieldPresenter field={field as SingleFormField} disabled={disabled} />
  ),
  flattenLeaves: field => [field as SingleFormField],
  buildInitialState: buildSingleFieldInitialState,
};
